import React from 'react';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import ModalFooter from 'react-bootstrap/ModalFooter';
import { Formik } from 'formik';
import Container from 'react-bootstrap/Container';

type EditState = {
    show: boolean,
    validated: boolean
    //mon?: UptimeMonitor
}

type EditProps = {
    //id?: string,
    show: boolean
    mon?: UptimeMonitor
    showAddBtn: boolean
    closeCBFunc: Function
}

interface UptimeMonitor {
    id?: string
    name?: string;
    endpoint?: string;
}

export default class UptimeMonEdit extends React.Component<EditProps, EditState> {
    constructor(props: EditProps) {
        super(props)
        this.state = { show: props.show, validated: false }
        this.handleModal = this.handleModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps: EditProps) {
        if (this.props.show && !this.state.show) {
            this.setState({ show: this.props.show })
        }
    }

    closeModal() {
        this.setState({ show: false })
        this.props.closeCBFunc();
    }

    handleModal(event: any) {
        this.setState({ show: true })
    }

    async handleSubmit(values: UptimeMonitor, { setSubmitting }: any) {
        if (this.props.mon) {
            let result = await fetch(new Request(process.env.REACT_APP_API_URL + `/api/uptime/monitors/${this.props.mon?.id}`, {
                credentials: 'include',
                method: "put",
                body: JSON.stringify({
                    id: this.props.mon?.id,
                    ...values
                })
            }));
            if (result.ok) {
                window.location.reload();
            } else if (result.status === 400) {
                alert(await result.text())
            } else {
                alert("An unknown error occurred. Please try again.")
            }
        } else {
            let result = await fetch(new Request(process.env.REACT_APP_API_URL + "/api/uptime/monitors", {
                credentials: 'include',
                method: "post",
                body: JSON.stringify(values)
            }));
            if (result.status === 400) {
                alert(await result.text())
            } else if (result.status === 500) {
                alert("An unknown error occurred. Please try again.")
            } else {
                window.location.reload();
            }
        }

        setSubmitting(false);
    };

    render() {

        return (
            <Container fluid>
                {this.props.showAddBtn ?
                    <Button variant="success" onClick={this.handleModal}>Add Monitor</Button> :
                    null
                }

                <Modal show={this.state.show} onHide={this.closeModal} >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.mon ? "Edit" : "Create"} Monitor</Modal.Title>
                    </Modal.Header>
                    <Formik
                        initialValues={{ name: this.props?.mon?.name, endpoint: this.props?.mon?.endpoint }}
                        validate={values => { return {}; }}
                        onSubmit={this.handleSubmit}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                        }) => (

                            <Form onSubmit={

                                handleSubmit as any
                            }>
                                <Modal.Body>

                                    <Form.Group controlId="formName">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control name="name" onChange={handleChange} onBlur={handleBlur}
                                            value={values.name} required type="text" maxLength={100} placeholder="Enter name" />
                                    </Form.Group>

                                    <Form.Group controlId="formendpoint">
                                        <Form.Label>Endpoint</Form.Label>
                                        <Form.Control name="endpoint" onChange={handleChange} onBlur={handleBlur} disabled={this.props.mon ? true : false}
                                            value={values.endpoint} required type="url" placeholder="https://google.com" />
                                    </Form.Group>


                                </Modal.Body>
                                <ModalFooter>
                                    <Button variant="secondary" onClick={this.closeModal}>Cancel</Button>
                                    <Button disabled={isSubmitting} type="submit" variant="primary">Save changes</Button>
                                </ModalFooter>
                            </Form>)}
                    </Formik>
                </Modal>
            </Container>
        )
    }
}